// extracted by mini-css-extract-plugin
export default {"overlay":"CardDownloadOverlay_overlay__btzlu","label":"CardDownloadOverlay_label__d9BwQ","progress":"CardDownloadOverlay_progress__O-dIl"};